import _localStorage from './localStorage.js';

/** Clipboard per gestire copia / incolla
* type: calendario | periodo
* data: int | object
* Nel caso di type "calendario", può contenere solo un valore, dove id = calendario_id
* Nel caso di type "periodo", contiene un array di oggetti di tipo {id, week, day}
*/
const clipboard = {
    copy: function  (obj) {
        _localStorage.setJSON('clipboard', obj);
    },

    paste: function  () {

        return _localStorage.getJSON('clipboard');
    },

    clear: function  () {
        _localStorage.remove('clipboard');
    },

    isEmpty: function () {

        return !_localStorage.get('clipboard');
    },

    typeOf: function (type) {
        let cb = this.paste();

        if (!(cb && cb.type)) {
        
            return false;
        }

        return cb.type === type;
    }
}

export { clipboard as default };
